import { gql } from '@apollo/client';

export type DeletePaymentMethodMutationVariables = {
  id: string;
};

export type DeletePaymentMethodMutation = {
  deletePaymentMethod: {
    __typename: 'RestDeletePaymentMethod';
  };
};

export const DELETE_PAYMENT_METHOD_MUTATION = gql`
  mutation DeletePaymentMethodMutation($id: String!) {
    deletePaymentMethod(id: $id)
      @rest(
        type: "RestDeletePaymentMethod"
        endpoint: "cart"
        path: "/v3.5/payments/{args.id}"
        method: "DELETE"
      ) {
      NoResponse
    }
  }
`;
